const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20pt",
    height: "20pt",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 17.089844 15.101562 L 11.988281 10 L 17.089844 4.898438 C 17.640625 4.347656 17.640625 3.460938 17.089844 2.910156 C 16.539062 2.359375 15.652344 2.359375 15.101562 2.910156 L 10 8.011719 L 4.898438 2.910156 C 4.347656 2.359375 3.460938 2.359375 2.910156 2.910156 C 2.359375 3.460938 2.359375 4.347656 2.910156 4.898438 L 8.011719 10 L 2.910156 15.101562 C 2.359375 15.652344 2.359375 16.539062 2.910156 17.089844 C 3.460938 17.640625 4.347656 17.640625 4.898438 17.089844 L 10 11.988281 L 15.101562 17.089844 C 15.652344 17.640625 16.539062 17.640625 17.089844 17.089844 C 17.636719 16.539062 17.636719 15.648438 17.089844 15.101562 Z M 17.089844 15.101562 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7f06bb6133d948847028b327771ec9f9.svg";
export { ForwardRef as ReactComponent };